import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LarsExportResponse, LarsExportRequest } from '@monorepo/interfaces';

@Injectable({ providedIn: 'root' })
export class LarsExportService {
    private apiUrl = environment.apiConfig[1].uri;
    private httpClient = inject(HttpClient);

    public getLarsExportLinks(accountingUnitIds: string[], period: string): Observable<LarsExportResponse> {
        const body: LarsExportRequest = {
            accountingUnitIds,
            month: new Date(period)
        };
        return this.httpClient.post<LarsExportResponse>(`${this.apiUrl}/fleet/export/lars`, body);
    }
}
